import { Navigate, useLocation } from 'react-router-dom';
import { useGroups } from '@/contexts/GroupsContext';
import { useHomes } from '@/contexts/HomesContext';
import {
  ACCOUNT_SETTINGS_PARAM,
  type AccountSettingsPaneId,
  withAccountSettings,
} from './account-settings';

interface ProfileLegacyRedirectProps {
  pane: AccountSettingsPaneId;
}

const LAST_WORKSPACE_KEY = 'cohaven_last_workspace';

export function ProfileLegacyRedirect({ pane }: ProfileLegacyRedirectProps) {
  const location = useLocation();
  const { homes } = useHomes();
  const { groups } = useGroups();
  const params = new URLSearchParams(location.search);

  if (params.get(ACCOUNT_SETTINGS_PARAM) === pane) {
    return null;
  }

  let remembered: string | null = null;
  try {
    remembered = sessionStorage.getItem(LAST_WORKSPACE_KEY);
  } catch {
    remembered = null;
  }

  const home = homes.find((entry) => entry.id === remembered) ?? homes[0];
  const group = groups.find((entry) => entry.id === remembered) ?? groups[0];
  const pathname = home ? `/home/${home.id}` : group ? `/groups/${group.id}` : '/profile';

  return <Navigate to={withAccountSettings(pathname, location.search, pane)} replace />;
}
